/** @module Merchandising/PropagateToLevels */
define([
    "dojo/_base/declare",
    "csi",
    "csi/_base/storage",
    "csi/action/Controller",
    "csi/xml",
    "csi/xml/Query"
], function(declare,csi,storage,Controller,xml,Query) {

    return declare(Controller, {

        applyActionFilters: function(/*csi.view.Widget*/view) {
            const urlSecondaryType = this.widget.urlSecondaryType || storage.get("MerchSecondaryPlanSubtype");
            view.relRoot.addQuery(new Query().RefAttr("Subtype", xml.OP_EQUALS, urlSecondaryType, "Child:__Parent__"), true);
            this.inherited(arguments);
        }

    });
});